import React, {Component} from 'react';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';

class SmartIdForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            code: null,
            hasCode: false,
            token: null,
            left_minutes: 0,
            left_seconds: 0,

            data: {personal_code: ''},
            initialStatus: {},
        };

        this.startPingingForLogin = this.startPingingForLogin.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.renderFormik = this.renderFormik.bind(this);
    }

    onSubmit(values, actions) {
        this.setState({data: values});
        axios.post('/api/user/smartid', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    this.startPingingForLogin(data.data, actions);
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    startPingingForLogin(data, actions) {
        stop();

        if (data.control_code === undefined || data.token === undefined) {
            actions.setSubmitting(false);
            return;
        }

        this.setState({
            code: data.control_code,
            hasCode: true,
            left_minutes: 2,
            left_seconds: 0,
            token: data.token
        });

        let _this = this;

        function handle() {

            if (_this.state.left_minutes > 0 || _this.state.left_seconds > 0) {
                axios.post('/api/user/smartid/status', {token: _this.state.token})
                    .then(
                        data => {
                            if (data.data.status === 'done') {
                                _this.stop();
                                _this.props.mark_as_logged_in();
                            } else {
                                setTimeout(handle, 1000);
                            }
                        },
                        error => {
                            let response_data = error.response.data;
                            _this.setState({initialStatus: {msg: response_data.message}});
                            _this.stop();

                        }
                    )
                    .catch((a, b, c) => {
                        console.log(a, b, c);
                    });
            } else {
                _this.setState({initialStatus: {msg: this.props.t('forms.signin_timeout')}});
                _this.stop();
            }
        }

        function handle_timer() {
            let minutes_left = _this.state.left_minutes;
            let seconds_left = _this.state.left_seconds - 1;

            if (seconds_left < 0) {
                minutes_left--;
                seconds_left = 59;
            }

            if (minutes_left < 0) {
                _this.setState({initialStatus: {msg: this.props.t('forms.signin_timeout')}});
                _this.stop();
            }

            _this.setState({
                left_minutes: minutes_left,
                left_seconds: seconds_left
            })
        }

        handle();
        this.timer_interval = setInterval(handle_timer, 1000);
    }

    stop() {
        clearInterval(this.timer_interval);
        this.timer_interval = null;

        this.setState({
            code: null,
            hasCode: false,
            token: null,
        });
    }

    renderFormik(props) {
        return (
            <div>
                <Form>
                    <div className="form-group">
                        <label className="form-label"
                               htmlFor="personal_code">{this.props.t('forms.personal_code')}</label>
                        <Field type="text" name="personal_code" id="personal_code"
                               className={'form-control' + (props.errors.personal_code && props.touched.personal_code ? ' is-invalid' : '')}/>
                        <ErrorMessage name="personal_code" component="div" className="invalid-feedback"/>
                    </div>

                    {props.status && props.status.msg && <div>{props.status.msg}</div>}

                    <div className="form-group">
                        <button type="submit" className="btn btn-primary btn-block" disabled={props.isSubmitting}>
                            {this.props.t('forms.login')}
                        </button>
                    </div>

                </Form>
            </div>
        );
    }

    render() {
        if (this.state.is_logged_in) {
            return (<Redirect push={true} to="/dashboard"/>)
        }

        return (
            <div>
                {!this.state.hasCode ?
                    (<Formik
                        initialValues={this.state.data}
                        onSubmit={this.onSubmit}
                        render={this.renderFormik}
                        initialStatus={this.state.initialStatus}
                    />)
                    :
                    (<div className='smartid-code-card'>

                        <p>{this.props.t('forms.signin_check_code_reminder')}
                            <span className='code'>{this.state.code}</span></p>

                        <p>{this.props.t('forms.awaiting_for_your_confirmation')}
                            <span
                                className='time'>{this.state.left_minutes}:{this.state.left_seconds < 10 ? 0 : ''}{this.state.left_seconds}</span>
                        </p>
                    </div>)
                }
            </div>
        );
    }
}

export default withTranslation()(SmartIdForm);
